const theme = {
  light_theme: "Claro",
  dark_theme: "Escuro",
  default_theme: "Preferência do equipamento",
};

export default theme;
